import Reports from "./Reports.vue";

export default [
    {
        path: "/reports/:reportName",
        component: Reports,
        name: "reports",
    },
];
